import { Button, ButtonProps } from "@mui/material";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { USE_SELECTED_INDEX } from "../hooks/useSelectedElement";

const AddElementDialog = React.lazy(() => import("./AddElementDialog"));

const AddBtn: React.FC<ButtonProps> = (props) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const setIndex = useSetRecoilState(USE_SELECTED_INDEX);

  const handleClick = () => {
    setIndex(null);

    setOpen(true);
  };

  return (
    <React.Fragment>
      <Button size="small" variant="contained" {...props} onClick={handleClick}>
        AJOUTER UN ELEMENT
      </Button>
      {open && (
        <React.Suspense>
          <AddElementDialog setOpen={setOpen} />
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

export default AddBtn;
